"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeObject = exports.encodeObject = exports.decodeUint8Array = exports.encodeUint8Array = exports.decodeArrayBuffer = exports.encodeArrayBuffer = exports.decode = exports.encode = void 0;
function encode(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
}
exports.encode = encode;
function decode(str) {
    return decodeURIComponent(escape(window.atob(str)));
}
exports.decode = decode;
var encodeArrayBuffer = function (arrayBuffer) {
    return (0, exports.encodeUint8Array)(new Uint8Array(arrayBuffer));
};
exports.encodeArrayBuffer = encodeArrayBuffer;
var decodeArrayBuffer = function (base64) {
    var str = window.atob(base64);
    var buffer = new ArrayBuffer(str.length);
    var uint8Array = new Uint8Array(buffer);
    for (var i = 0; i < str.length; i++) {
        uint8Array[i] = str.charCodeAt(i);
    }
    return buffer;
};
exports.decodeArrayBuffer = decodeArrayBuffer;
var encodeUint8Array = function (uint8Array) {
    var output = [];
    for (var i = 0; i < uint8Array.length; i++) {
        output.push(String.fromCharCode(uint8Array[i]));
    }
    return window.btoa(output.join(''));
};
exports.encodeUint8Array = encodeUint8Array;
var decodeUint8Array = function (base64) {
    var str = window.atob(base64);
    var uint8Array = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) {
        uint8Array[i] = str.charCodeAt(i);
    }
    return uint8Array;
};
exports.decodeUint8Array = decodeUint8Array;
function encodeObject(obj) {
    return encode(JSON.stringify(obj));
}
exports.encodeObject = encodeObject;
function decodeObject(str) {
    if (str) {
        try {
            return JSON.parse(decode(str));
        }
        catch (e) {
            console.log(e);
        }
    }
    return {};
}
exports.decodeObject = decodeObject;
//# sourceMappingURL=base64.js.map